// Windsurf generated file
import React from 'react'
import { useFeatureFlags } from '../shared/use-feature-flags'
import { useAuth } from '../auth/auth-hooks'
import { UserType } from '../../api/auth-api'

interface DevOnlyProps {
  children: React.ReactNode
}

/**
Wrapper component that only renders children when ENABLE_DEV_TOOLS feature flag is enabled and user is authorized.

Use this to wrap dev tools that should only be visible when the feature flag is active and the user has access.

@example
```tsx
Inside a dev tool component:
export const MyDevTool = () => {
  return (
    <DevOnly>
      <div>Debug panel content</div>
    </DevOnly>
  )
}
``` 

@example
```tsx
For global dev tools, add at app level:
export default function App() {
  return (
    <>
      <AppContent />
      <FeatureFlagDebugPanel /> { Wraps itself with DevOnly internally }
    </>
  )
}
``` 
*/

export function DevOnly({ children }: DevOnlyProps) {
  const { flags } = useFeatureFlags()
  const { userType } = useAuth()
  const isLocalDev = import.meta.env.DEV

  // Don't show dev tools if user is not authorized
  if (userType === UserType.NOT_VALID) {
    return null
  }

  if (!isLocalDev && !flags.ENABLE_DEV_TOOLS) {
    return null
  }

  return <>{children}</>
}
